import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../../src/config";
import { toast } from "react-toastify";

const LoginForm = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [serverError, setServerError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  //. handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  //. validate before submit
  const validate = () => {
    let newErrors = {};
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }
    return newErrors;
  };

  //. handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerError("");
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setErrors({});
    setLoading(true);

    try {
      const response = await axios.post(
        `${API_BASE_URL}auth/login`,
        formData
      );

      if (response.data.success) {
        const { accessToken, refreshToken, stayId, ...user } = response.data.data;
         const normalizedUser = {
    ...user,
    firstName: user.firstname, // map API field to camelCase
    lastName: user.lastname,
  };

        //. Save tokens and user details
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
       
        if (stayId) {
          localStorage.setItem("stayId", stayId);
        }
        localStorage.setItem("user", JSON.stringify(normalizedUser));

        console.log("Login success:", response.data);
         //. Check if user was redirected here after clicking Book Now
      const redirectData = JSON.parse(localStorage.getItem("redirectAfterLogin") || "{}");

      if (redirectData.path) {
        localStorage.removeItem("redirectAfterLogin");
        // Navigate back to intended page (e.g., property page)
        window.location.href = redirectData.path;
      } else {
        // Default fallback
        navigate("/");
      }

        // Redirect after login
       // navigate("/profile");
      } else {
        toast.error(response.data.message || "Login failed");
        // setServerError(response.data.message || "Login failed");
      }
    } catch (err) {
      console.error("Login failed:", err);
      toast.error(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="logincontainer">
      <div className="container">
        <div className="row justify-content-center">
          {/* Left side */}
          <div className="col-xxl-5 col-xl-4 col-lg-6 col-md-5 col-sm-12 col-12 align-self-center">
            <div className="logintextbox">
              <div className="loginheading">Become a Member</div>
              <p>Enter your personal details and start your journey with us.</p>
              <Link to="/register" className="theme-btn signupbtn">
                Sign Up
              </Link>
            </div>
          </div>

          {/* Right side */}
          <div className="col-xxl-5 col-xl-5 col-lg-6 col-md-7 col-sm-12 col-12 align-self-center">
            <div className="loginbox">
             {/* <div className="loginheading">WELCOME BACK!</div> */}
              <div className="loginheading">Sign In</div>
              <p>Sign in to continue to your dashboard.</p>

              <form onSubmit={handleSubmit}>
                {/* Email */}
                <div className="form-group">
                  <div className="formgroupinner">
                    <i className="fa fa-user-o"></i>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Email ID"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.email && (
                    <small className="text-danger">{errors.email}</small>
                  )}
                </div>

                {/* Password */}
                <div className="col-12">
  <div className="form-group">
    <div className="formgroupinner" style={{ position: "relative" }}>
      {/* <i className="fa fa-key"></i> */}

      <input
        type={showPassword ? "text" : "password"}
        name="password"
        value={formData.password}
        onChange={handleChange}
        className={`form-control ${
          errors.password ? "is-invalid" : "is-valid"
        }`}
        placeholder="Password"
        required
      />

      {/* EYE ICON */}
      <i
        className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
        onClick={() => setShowPassword(!showPassword)}
        style={{
          position: "absolute",
          right: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          fontSize: "18px",
          color: "#666"
        }}
      ></i>
    </div>

    {errors.password && (
      <small className="text-danger">{errors.password}</small>
    )}
  </div>
</div>

{/* 
                {serverError && (
                  <div className="alert alert-danger">{serverError}</div>
                )} */}

                <button
                  className="theme-btn loginbtn"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Signing In..." : "Sign In"}
                </button>

                <div className="tex-start mt-3">
                  <div className="row gx-1 align-items-center">
                    <div className="col-6">
                      <div className="checkbox">
                        <input type="checkbox" id="remember" name="remember" />
                        <label htmlFor="remember">Remember me</label>
                      </div>
                    </div>
                    {/* <div className="col-6">
                      <div className="forgotbox">
                        <Link to="/forgot">Forgot your password?</Link>
                      </div>
                    </div> */}
                    <div className="col-6">
  <div className="forgotbox">
    <Link to="/forgotpassword">Forgot your password?</Link>
  </div>
</div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoginForm;
